/**
 * Referral Tips
 * Tips section for getting more referrals
 */

import { Lightbulb, Share2 } from 'lucide-react';
import { useLanguage } from '../../../../contexts/LanguageContext';

export function ReferralTips() {
  const { t } = useLanguage();

  const tips = [
    t('referrals.tip1', 'Share your code with IKEA-loving friends and family'),
    t('referrals.tip2', 'Post your QR code on social media'),
    t('referrals.tip3', 'Print decals and share them at IKEA meetups or local stores'),
    t('referrals.tip4', 'Mention Rumio when you spot great As-Is deals'),
    t('referrals.tip5', 'Add your referral link to your email signature'),
  ];

  return (
    <div className="bg-blue-50 border border-blue-200 rounded-2xl p-6">
      <div className="flex items-start gap-4">
        <div className="p-2 bg-blue-100 rounded-lg shrink-0">
          <Lightbulb className="w-5 h-5 text-blue-600" />
        </div>
        <div>
          <h3 className="font-semibold text-blue-900 mb-2">
            {t('referrals.tipsTitle', 'Tips for More Referrals')}
          </h3>
          <ul className="space-y-2">
            {tips.map((tip, index) => (
              <li key={index} className="flex items-start gap-2 text-sm text-blue-800">
                <Share2 className="w-3.5 h-3.5 text-blue-500 mt-0.5 shrink-0" />
                <span>{tip}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
